import React from "react";
import { text } from "../../../utils/styles/style";
import NumberFormat from "react-number-format";
import moment from "moment";

function InfoTrx(props) {
  const { custData, paymentStatus, totalStatus } = props;

  return (
    <>
      <div style={{ padding: "0 2rem" }}>
        <div className="doted space-between" style={{ margin: "20px 0" }} />
        <div className="paymentStatus-container">
          <div className="deposit-via-info">
            <p className="status-label">Cash In amount</p>
            <p className="">
              {"RM"}{" "}
              <NumberFormat
                value={parseFloat(custData.amount).toFixed(2)}
                thousandSeparator={true}
                displayType="text"
                decimalSeparator="."
              />
            </p>
          </div>
          <div className="deposit-via-info">
            <p>Administrative fee</p>
            <p className="">
              {"RM"} {parseFloat(paymentStatus.fee).toFixed(2)}
            </p>
          </div>
          <div className="deposit-via-info">
            <p className="status-label">Cash In via</p>
            <p className="">{paymentStatus.payCatDesc || "No Data"}</p>
          </div>
          <div className="deposit-via-info">
            <p className="status-label">Date</p>

            <p className="">
              {moment(paymentStatus.pgTrxTime || new Date())
                .utcOffset(8)
                .format("DD MMM YYYY")}
            </p>
          </div>
          <div className="deposit-via-info">
            <p className="status-label">Time</p>
            <p className="">
              {moment(paymentStatus.pgTrxTime || new Date())
                .utcOffset(8)
                .format("hh:mm:ss A")}
            </p>
          </div>
          <div className="deposit-via-info">
            <p>Reference no</p>
            <p className="ref-no">{paymentStatus.pgRefNo || "No Data"}</p>
          </div>
          <div className="deposit-via-info">
            <p>Transaction no</p>
            <p className="ref-no">{paymentStatus.trxRefNo || "No Data"}</p>
          </div>
          <div className="deposit-via-info">
            {paymentStatus.customerChannelCode === "Mini Program" ? (
              <p className="status-label">Touch'n Go eWallet Transaction Id</p>
            ) : (
              <p className="status-label">FPX Transaction Id</p>
            )}
            <p className="trx-id">{paymentStatus.payRefNo || "Inprogress"}</p>
          </div>

          <div className="deposit-via-info">
            <p className="bolded-total" style={{ color: text.color.blue }}>
              Total :
            </p>
            <p style={{ color: text.color.blue }} className="bolded-total">
              {"RM"}{" "}
              <NumberFormat
                value={totalStatus}
                thousandSeparator={true}
                displayType="text"
                decimalSeparator="."
                className="bolded-total"
              />
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default InfoTrx;
